/*
根據舊的state和指定的action生成新的state的函式
*/
import { combineReducers } from 'redux'
import {
    SET_HEAD_TITLE, RECERVE_USER, RESET_USER, SHOW_ERROR_MSG
} from './action-types'
import storageUtils from '../utils/storageUtils'

/*
管理[頭部標題]的reducer函數
*/
const initHeadTitle = ''
function headTitle(state = initHeadTitle, action) {
    switch (action.type) {
        case SET_HEAD_TITLE:
            return action.data
        default:
            return state
    }
}

/*
管理[當前用戶]的reducer函數
*/
const initUser = storageUtils.getUser()
function user(state = initUser, action) {
    switch (action.type) {
        case RECERVE_USER:
            return action.user
        case SHOW_ERROR_MSG:
            const error_msg = action.data
            return { ...state, error_msg }
        case RESET_USER:
            return {}
        default:
            return state
    }
}

/*
{
    headTitle: '首頁',
    user: {}
}
*/
export default combineReducers({
    headTitle,
    user
})